// FAQ-data separerad från guidekomponenten så att route-huvudet kan
// importera den utan att dra in hela guiden i startbundlen.
export const BINDER_FAQS: { q: string; a: string }[] = [
  {
    q: "Är egenkontrollprogram lagstadgat för alkoholservering?",
    a: "Ja. Enligt 8 kap. 5 § alkohollagen (2010:1622) ska den som ansöker om serveringstillstånd visa att verksamheten kommer att drivas i enlighet med lagen, och kommunen kräver i praktiken ett skriftligt egenkontrollprogram. Programmet ska finnas tillgängligt på serveringsstället och kunna visas vid tillsyn.",
  },
  {
    q: "Vad är skillnaden mellan egenkontrollprogram och egenkontrollpärm?",
    a: "Egenkontrollprogrammet är själva dokumentet som beskriver era rutiner. Egenkontrollpärmen är hela samlingen: programmet plus de loggar, checklistor, personallistor och incidentrapporter som visar att rutinerna faktiskt följs i vardagen. Kommunen vill ofta se båda delarna.",
  },
  {
    q: "Vad ingår i egenkontrollpärmen från Alkoholprovet?",
    a: "Ett färdigt egenkontrollprogram att fylla i, rutiner för ålderskontroll, överservering och nekad servering, ansvarsfördelning och personallista, introduktionsrutin för ny personal, avvikelse- och incidentloggar samt checklistor för öppning, stängning och månadsuppföljning. Allt levereras som utskriftsklar PDF och redigerbar Word-fil.",
  },
  {
    q: "Vad kostar egenkontrollpärmen?",
    a: "790 kr inkl. moms som engångsköp utan medlemskap. Som aktiv Premiummedlem betalar du 395 kr. Köper du Premium 90 dagar för 599 kr ingår pärmen utan extra kostnad.",
  },
  {
    q: "Måste jag skriva om pärmen för min egen verksamhet?",
    a: "Ja, du ska anpassa den. Word-filen är redigerbar just därför: kommunen vill se rutiner som stämmer med er faktiska drift – öppettider, serveringsyta, personalstyrka, entrévärdar och eventuell uteservering. En pärm som är kopierad rakt av utan anpassning är en vanlig anmärkningsorsak.",
  },
  {
    q: "Hur ofta ska egenkontrollen uppdateras?",
    a: "Vid varje väsentlig förändring – ny serveringsansvarig, ändrade öppettider, ny ägarstruktur, ombyggnation – och därutöver minst en gång per år. Datera varje revidering i pärmen så att kommunen ser att den är levande.",
  },
  {
    q: "Vad händer om vi saknar egenkontrollprogram vid tillsyn?",
    a: "Kommunen kan meddela erinran eller varning enligt 9 kap. 17 § alkohollagen. Vid upprepade eller allvarliga brister kan serveringstillståndet återkallas. Saknade dokumenterade rutiner är en av de vanligaste anmärkningarna vid inre och yttre tillsyn.",
  },
  {
    q: "Räcker pärmen för att klara kunskapsprovet?",
    a: "Nej. Pärmen är ett driftverktyg, inte ett studiematerial. För kunskapsprovet hos kommunen övar du med våra provfrågor och provsimuleringar – pärmen använder du efter att tillståndet är på plats.",
  },
  {
    q: "Får jag uppdateringar när reglerna ändras?",
    a: "Du kan hämta filerna på nytt från Min sida. När vi uppdaterar pärmen inför nya regeländringar hittar du den nya utgåvan där utan extra kostnad.",
  },
  {
    q: "Kan flera restauranger i samma bolag använda samma pärm?",
    a: "Egenkontrollen ska spegla varje serveringsställe. Har ni flera enheter behöver varje ställe en egen ifylld pärm med egen ansvarsfördelning och egna loggar, även om grundmallen är densamma.",
  },
];
